import { useState, useEffect } from "react";
import { Heart, HandHeart, ShieldCheck, Ban } from "lucide-react";
import { LOGO } from "../lib/constants";
import { Button } from "./ui/button";

const KEY = "haplap_welcome_v1";

const RULES = [
  { icon: Ban, text: "No bullying, harassment, or hate — ever." },
  { icon: Heart, text: "Never shame anyone for asking for help." },
  { icon: HandHeart, text: "Never shame anyone for the way they give." },
  { icon: ShieldCheck, text: "Treat every neighbour with dignity and kindness." },
];

export default function WelcomeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setOpen(true); } catch { /* ignore */ }
  }, []);

  const agree = () => {
    // This click is a genuine user gesture — fire it synchronously so the hero
    // video is allowed to start playing WITH sound right after.
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ }
    window.dispatchEvent(new Event("haplap:agreed"));
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div data-testid="welcome-gate" className="fixed inset-0 z-[120] overflow-y-auto bg-bronze/70 backdrop-blur-md animate-in fade-in duration-200">
      <div className="min-h-full flex items-center justify-center p-4">
        <div className="relative bg-card w-full max-w-md rounded-3xl border border-border shadow-2xl p-5 sm:p-8 my-4 text-center flex flex-col items-center animate-in zoom-in-95 duration-200">
          <img src={LOGO} alt="HAPLAP" className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl object-cover shadow-sm" />
          <h2 className="font-serif text-xl sm:text-3xl font-bold text-bronze mt-3 sm:mt-4">Welcome to HAPLAP</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-copper via-penny to-sage rounded-full my-2.5 sm:my-3 opacity-90" />
          <p className="text-xs sm:text-sm text-foreground/75 leading-relaxed max-w-sm">
            This is a warm, safe place to ask for help and to give it — with zero judgment.
            Before you come in, please agree to how we treat each other:
          </p>

          <ul className="w-full space-y-2 sm:space-y-2.5 mt-4 sm:mt-5 text-left">
            {RULES.map((r) => (
              <li key={r.text} className="flex items-start gap-2.5 sm:gap-3 bg-secondary/60 rounded-2xl px-3 py-2 sm:px-3.5 sm:py-2.5">
                <span className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-copper/15 text-copper flex items-center justify-center shrink-0"><r.icon className="w-3 h-3 sm:w-3.5 sm:h-3.5" /></span>
                <span className="text-xs sm:text-sm text-foreground/85 leading-snug">{r.text}</span>
              </li>
            ))}
          </ul>

          <Button data-testid="welcome-agree-btn" onClick={agree}
            className="w-full mt-5 sm:mt-6 rounded-full bg-copper hover:bg-copper/90 text-white py-5 sm:py-6 text-sm sm:text-base">
            I agree — let me in 💛
          </Button>
          <p className="text-[11px] text-muted-foreground mt-2.5 sm:mt-3">By entering you accept our community guidelines. Breaking them means removal, no exceptions.</p>
        </div>
      </div>
    </div>
  );
}
